import { render, staticRenderFns } from "./zws-steps1.vue?vue&type=template&id=2fb0a75e&scoped=true"
import script from "./zws-steps1.vue?vue&type=script&lang=js"
export * from "./zws-steps1.vue?vue&type=script&lang=js"
import style0 from "./zws-steps1.vue?vue&type=style&index=0&id=2fb0a75e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0a75e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb0a75e')) {
      api.createRecord('2fb0a75e', component.options)
    } else {
      api.reload('2fb0a75e', component.options)
    }
    module.hot.accept("./zws-steps1.vue?vue&type=template&id=2fb0a75e&scoped=true", function () {
      api.rerender('2fb0a75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/zws-steps1.vue"
export default component.exports